import React from 'react';
import { NavLink } from 'react-router-dom';
import Header from './../Common/Header';
import Footer from './../Common/Footer';
import Banner from './../Elements/Banner';

var bnrimg = require('./../../images/s5/b1.jpg');

class Services_5 extends React.Component {
    render() {
        return (
            <>
                <Header />
                <div className="page-content">
                    <Banner
                        title="No Leaks. No Delays. Just Dependable Flow."
                        pagename="Plumbing Solutions"
                        bgimage={bnrimg}
                    />

                    <div className="section-full p-tb80 inner-page-padding">
                        <div className="container">
                            <div className="blog-single-wrap-width">
                                <div className="blog-post date-style-3 blog-detail text-black">
                                    <div className="mt-post-media clearfix m-b30">
                                        <ul className="grid-post">
                                            <li>
                                                <div className="portfolio-item">
                                                    <img
                                                        className="img-responsive"
                                                        src={require("./../../images/s5/b2.jpg")}
                                                        alt="Plumbing Services"
                                                    />
                                                </div>
                                            </li>
                                        </ul>
                                    </div>

                                    <div className="mt-post-title">
                                        <h3 className="post-title font-weight-600">Plumbing Solutions</h3>
                                    </div>

                                    <div className="mt-post-text">
                                        <p>
                                            At <strong>I-Smart Engineering Works</strong>, we provide reliable, code-compliant plumbing services for residential, commercial, and industrial projects. Whether it's leak detection, drainage design, or total pipework, we act with the precision of an engineer and the discipline of a sailor.
                                        </p>

                                        <p>
                                            Our solutions are built to last — no guesswork, no short fixes. Just clean installations and maintenance you can depend on. We don’t just connect pipes, we protect your flow — day in, day out.
                                        </p>

                                        <h4 className="font-weight-600">Our Plumbing Services Include:</h4>
                                        <ul className="list-angle-right">
                                            <li>New water line & sanitary plumbing installations</li>
                                            <li>Drainage and sewage piping layout</li>
                                            <li>Bathroom, kitchen & utility plumbing setups</li>
                                            <li>Leak detection and pressure testing</li>
                                            <li>AMC for periodic checks & emergency repairs</li>
                                        </ul>

                                        <blockquote className="bg-dark text-white author-quote">
                                            <h4 className="m-b0">
                                                “Leaks are the enemy. Precision is the shield. In ships or cities, water obeys discipline.” <i className="fa fa-quote-right" />
                                            </h4>
                                            <div className="p-t15 text-white">
                                                <strong className="text-primary">Lt. Commander R. Velasquez</strong>
                                                <span>Navy Technical Division</span>
                                            </div>
                                        </blockquote>

                                        <p>
                                            We use only standard-approved materials and ensure tight, professional finishes. From PVC to PEX, GI to CPVC, we’re fluent in every pipe language — and we install them like clockwork.
                                        </p>

                                        {/* <div className="row">
                                            <div className="col-md-4 col-sm-4">
                                                <div className="mt-box m-b30">
                                                    <div className="mt-media">
                                                        <img src={require("./../../images/blog/large-blog.jpg")} alt="Pipe Installation" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-4 col-sm-4">
                                                <div className="mt-box m-b30">
                                                    <div className="mt-media">
                                                        <img src={require("./../../images/blog/large-blog2.jpg")} alt="Drainage Work" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-4 col-sm-4">
                                                <div className="mt-box m-b30">
                                                    <div className="mt-media">
                                                        <img src={require("./../../images/blog/large-blog3.jpg")} alt="Bathroom Plumbing" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div> */}

                                        <p>
                                            <strong>Don’t wait for water to become a problem.</strong> Call us today to schedule your plumbing assessment or pipework upgrade. We flow where others falter.
                                        </p>
                                    </div>

                                    <div className="autor-post-tag-share bdr-t-1 bdr-solid bdr-gray p-t20">
                                        <div className="row">
                                            <div className="col-md-6 col-sm-6">
                                                <div className="widget widget_tag_cloud">
                                                    <h4 className="tagcloud">Tags</h4>
                                                    <div className="tagcloud">
                                                        <NavLink to={"#"}>Plumbing</NavLink>&nbsp;
                                                        <NavLink to={"#"}>Leak Repair</NavLink>&nbsp;
                                                        <NavLink to={"#"}>Drainage</NavLink>&nbsp;
                                                        <NavLink to={"#"}>Sanitary System</NavLink>&nbsp;
                                                        <NavLink to={"#"}>AMC Plumbing</NavLink>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </>
        );
    };
};

export default Services_5;
